export interface IConfig {
  fvAuthUrl: string;
  hostUrl: string;
  googleApiUrl: string;
  googleApiKey: string;
  googleApiClientId: string;
}

interface IShardGroup { key: string, name: string }

export const shardGroups: { [key: string]: IShardGroup[] } = {
  prod: [{ key: 'app', name: 'app.filevine.com (United States)' }],
  preprod: [{ key: 'fru', name: 'Free Range Unicorns' }, { key: 'jacksonville', name: 'Jacksonville' }],
};

export const envShards: IShardGroup[] | undefined = shardGroups[process.env.REACT_APP_GROUP || ''];

export const getConfig = (): IConfig => {
  return {
    fvAuthUrl: process.env.REACT_APP_FVAUTH_URL || '',
    hostUrl: process.env.REACT_APP_HOST || '',
    googleApiUrl: process.env.REACT_APP_GOOGLE_URL || '',
    googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
    googleApiClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  };
};